export default __webpack_public_path__ + "static/media/tr-icon.7eb2c560.svg";